<template>
  <div
    class="application application_order main-form"
    :class="{
      application_large: large,
    }"
    @click.stop
  >
    <div ref="hidden_helper"></div>

    <div class="application__header" v-if="!large">
      <span v-if="isNew">{{ $t("request.newRequestTitle") }}:</span>
      <span v-else>
        {{ dataEmployee.service.title }}
        <span>{{ dataEmployee.original_id }}</span>
      </span>

      <svg
        class="application__header-close"
        @click="$emit('closeModal')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
          fill="#0c0c0c"
        />
      </svg>
    </div>

    <div class="main-modal__title" v-else>
      <span v-if="!dataEmployee.service">{{ $t("request.newRequestTitle") }}:</span>
      <span v-else>
        {{ dataEmployee.service.title }}
        <span>#{{ dataEmployee.original_id }}</span>
      </span>
    </div>

    <div
      class="application-box application-box__body application-box__body_flex"
      :class="{
        'application-box_full': large,
        'application-box_pl0': large,
        'application-box__body_between': !large,
      }"
    >
      <div
        class="application-box__half"
        :class="{
          'application-box_w30': large,
        }"
      >
        <div class="application-box__sub">
          <span class="application-box__sub-label">{{ $t("listsHeader.createdAt") }}:</span>
          <span class="application-box__sub-text">{{ convertDateWithTime(dataEmployee.created_at) }}</span>
        </div>
      </div>

      <div class="application-box__half">
        <div class="application-box__sub">
          <span class="application-box__sub-label">{{ $t("forms.source") }}:</span>

          <span class="application-box__sub-text" v-if="dataEmployee.source">
            {{ convertSource(dataEmployee.source) }}
            <span
              v-if="dataEmployee.my_hammer"
            >{{ `( ${dataEmployee.my_hammer} )` }}</span>
          </span>
          <span class="application-box__sub-text" v-else>
            {{
            $t("forms.undefined")
            }}
          </span>
        </div>
      </div>
    </div>

    <div class="application__body">
      <div class="application-left">
        <!-- CLIENT INFO START  -->

        <template v-if="hasClient">
          <div class="application-box mb16">
            <div class="application-box__title">{{ $t("forms.client") }}</div>
            <div class="application-box__client">
              <img
                class="application-box__client-img"
                :src="getImage(dataEmployee.client.small_image)"
                alt
              />
              <div class="application-box__client-info">
                <p class="application-box__client-name">
                  {{ dataEmployee.client.first_name }}
                  {{ dataEmployee.client.last_name }}
                </p>
                <p class="application-box__client-email">{{ dataEmployee.client.email }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- <div
                class="application-user__img"
                :style="{
                  backgroundImage: getImage(dataEmployee.client.small_image),
                }"
              ></div>
              <div class="application-user__name">
                <span>{{ dataEmployee.contact.first_name }}</span>
                <span>{{ dataEmployee.contact.last_name }}</span>
                <span>( {{ dataEmployee.contact.email }} )</span>
          </div>-->
        </template>

        <!-- CLIENT INFO END  -->

        <!-- CONTACT INFO START  -->
        <div class="application-box mb16">
          <div class="application-box__title">{{ $t("forms.contactInfo") }}</div>
          <div
            class="application-box__body application-box__body_flex application-box__body_between"
          >
            <div class="application-box__half">
              <div>
                <!-- <el-input
                  :disabled="!$guard('write', 'Orders')"
                  :placeholder="$t('forms.name')"
                  v-model="dataEmployee.contact.first_name"
                ></el-input>-->
                <input
                  class="main-form__input"
                  type="text"
                  :disabled="!$guard('write', 'Orders') || !canEditOrder"
                  :placeholder="$t('forms.name')"
                  v-model="dataEmployee.contact.first_name"
                />
              </div>
            </div>
            <div class="application-box__half">
              <div>
                <!-- <el-input
                  :disabled="!$guard('write', 'Orders')"
                  :placeholder="$t('forms.surname')"
                  v-model="dataEmployee.contact.last_name"
                ></el-input>-->
                <input
                  class="main-form__input"
                  type="text"
                  :disabled="!$guard('write', 'Orders') || !canEditOrder"
                  :placeholder="$t('forms.surname')"
                  v-model="dataEmployee.contact.last_name"
                />
              </div>
            </div>
          </div>

          <div class="application-box__body mt15">
            <vue-tel-input
              v-model="dataEmployee.contact.phone"
              @validate="checkValue"
              :placeholder="$t('forms.phone')"
              :inputOptions="{ showDialCode: true }"
              mode="international"
              class="main-vue-tel-input"
              :disabled="!$guard('write', 'Orders') || !canEditOrder"
              :defaultCountry="defaultCountry"
            ></vue-tel-input>
          </div>
          <div class="application-box__body mt15" v-if="!hasClient">
            <input
              class="main-form__input"
              type="text"
              placeholder="E-mail"
              v-model="dataEmployee.contact.email"
              :disabled="!canEditOrder"
            />
          </div>
        </div>

        <div class="application-box mb16">
          <div @click="openAutocomplete">
            <!-- <el-input
              class="autocomplete-disable"
              disabled
              :value="
                `${dataEmployee.address.street} ${dataEmployee.address.house}, ${dataEmployee.address.postcode}, ${dataEmployee.address.city}`
              "
            />-->
            <!-- <input
              type="text"
              class="main-form__input autocomplete-disable"
              :value="clientAddress"
            />-->
            <span
              class="main-form__input autocomplete-disable"
              v-text="clientAddress"
              :disabled="!canEditOrder"
            ></span>
          </div>
          <div class="mt15">
            <input
              type="text"
              class="main-form__input"
              :placeholder="'Apt. /Büro'"
              v-model="dataEmployee.address.apartment"
              :disabled="!dataEmployee.address.street || !canEditOrder"
            />
          </div>
          <div class="mt15">
            <textarea
              class="main-form__textarea"
              :placeholder="$t('forms.addressComment')"
              v-model="dataEmployee.address.description"
              :disabled="!dataEmployee.address.street || !canEditOrder"
            ></textarea>
          </div>
        </div>
        <!-- CONTACT INFO END  -->
      </div>

      <div class="application-right">
        <!-- ORDER MEDIA AND PROBLEM START  -->
        <div class="application-box mb16">
          <div class="application-box__title">{{ $t("forms.orderAndImages") }}</div>

          <div
            class="application-box__body application-box__body_flex application-box__body_between"
          >
            <div v-if="hasDescription" style="width:100%">
              <textarea
                class="main-form__textarea"
                v-model="dataEmployee.description"
                placeholder="Problem"
                :disabled="!canEditOrder"
                ref="client-comment"
              ></textarea>
            </div>
            <div class="main-form__text" v-else>{{ $t("forms.noDescription") }}</div>
          </div>
        </div>

        <div class="application-box mb16" v-if="dataEmployee.conversation">
          <p>
            <span class="fw-bold">Shazam:</span>
            {{ dataEmployee.conversation }}
          </p>
        </div>

        <div class="application-box mb16">
          <div class="application-info__media" v-if="hasMedia">
            <div class="application-info__media-items">
              <div class="application-info__media-item" v-for="item in mutatedMedia" :key="item.id">
                <img :src="item.preview" alt @click="showMedia(item.original, item.type)" />
              </div>
              <button
                v-if="mutatedMedia.length >= 3"
                @click="toggleMediaGallery"
                class="media-gallery__btn"
              >{{ $t("forms.moreImages") }}..</button>
            </div>
          </div>
          <div class="main-form__text" v-else>{{ $t("forms.noImages") }}</div>
        </div>
        <!-- ORDER MEDIA AND PROBLEM END  -->

        <!-- ORDER MATEIALS START -->
        <div class="application-box mb16">
          <div class="application-box__title application-box__title_flex">
            <p>{{ $t("forms.materials") }}</p>

            <svg
              style="cursor:pointer"
              @click="openMaterialsModal"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
              <path
                d="M8.00012 4.66669V11.3334"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3332 8H4.6665"
                stroke="var(--menu-text-color)"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div v-for="item in materials" :key="item.material_id">
            <div class="application-material">
              <div>
                <img width="30px" :src="item.icon" alt />
              </div>
              <div class="application-material__name">{{ item.text }}</div>
              <div class="application-material__price">€{{ item.price }}</div>
              <div class="application-material__quantity">{{ item.qty }}X</div>
              <div class="application-material__price">€{{ item.price * item.qty }}</div>
            </div>
          </div>
        </div>
        <!-- ORDER MATEIALS END -->

        <!-- ORDER DETAILS START  -->
        <!-- <div class="application-box mb16">
          <div class="application-box__title">
            {{$t("navigation.services")}}
          </div>

          <div class="application-box__body">
            <Select2
              v-validate="'required'"
              data-vv-as="field"
              name="services"
              :options="services"
              :settings="selectSettingServices"
              v-model="service_id"
              class="select2-container_w100"
              @change="calculatePrice"
            />
          </div>
        </div>-->

        <div class="application-box mb16">
          <div class="application-box__title">{{ $t("forms.chooseDate") }}</div>

          <div class="application-box__body mb16" v-if="isNew || isConfirmed || isStandBy">
            <Select2
              v-validate="'required'"
              data-vv-as="field"
              name="services"
              :options="services"
              :settings="selectSettingServices"
              v-model="service_id"
              class="select2-container_w100 mb16"
              @change="changeService"
            />

            <!-- <Select2
              v-model="office_id"
              :options="filteredList"
              class="select select2-container_w100"
              :settings="selectSetting"
              placeholder="Office"
              @change="changeOffice"
              style="width:100%"
            />-->
          </div>

          <div class="application-box__body application-box__body_flex application-box_between">
            <div class="application-box__half">
              <div class="application-info__newdate">
                <el-date-picker
                  v-if="!isMultiDays"
                  class="multiple-days multiple-days_one"
                  v-model="dataEmployee.should_started_at"
                  type="datetime"
                  :placeholder="$t('request.dateHolder')"
                  default-time="12:00"
                  :pickerOptions="pickerOptions"
                  ref="datetime-picker-day"
                  effect="dark"
                  format="yyyy-MM-dd HH:mm"
                  @change="changeDate"
                  :editable="false"
                  :disabled="!canEditOrder"
                ></el-date-picker>

                <el-date-picker
                  v-if="isMultiDays"
                  class="multiple-days multiple-days_many"
                  type="dates"
                  v-model="multiDays"
                  :placeholder="$t('request.dateHolder')"
                  format="yyyy-MM-dd"
                  @change="changeDate"
                  :editable="false"
                  :disabled="!canEditOrder"
                ></el-date-picker>
              </div>
            </div>
            <div class="application-box__half">
              <div class="application-time__desc">
                <el-time-select
                  :disabled="
                    !$guard('write', 'Orders') || isMultiDays || !canEditOrder
                  "
                  class="application-time-picker application-time-picker_w150"
                  v-model="duration"
                  :picker-options="{
                    start: '00:30',
                    end: '10:00',
                    step: '00:15',
                  }"
                  placeholder="00:30"
                ></el-time-select>
              </div>
            </div>
          </div>
        </div>

        <div class="application-box application-box_flex application-box_between mb16">
          <div class="application-box__half short-text">
            <!-- <el-input
              :disabled="!$guard('write', 'Orders')"
              :placeholder="$t('listsHeader.price')"
              v-model="finalPrice"
              clearable
            ></el-input>-->
            <input
              class="main-form__input"
              type="text"
              :disabled="!$guard('write', 'Orders') || !canEditOrder"
              :placeholder="$t('listsHeader.price')"
              :value="recomendedFinalPrice"
              @change="onPriceChanged($event)"
            />
          </div>

          <div class="application-box__half short-text">
            <el-select
              :disabled="!$guard('write', 'Orders') || !canEditOrder"
              v-model="status"
              filterable
              placeholder="Select"
            >
              <el-option
                v-for="(item, index) in statusesModified"
                :key="index"
                :label="item.value"
                :value="item.status"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- <div
          v-if="dataEmployee.source"
          class="application-box application-box_flex application-box_between"
        >
          <p>
            <span style="font-weight:bold;font-size:13px">Source:</span>
            {{ dataEmployee.source }}
          </p>
        </div>-->
        <!-- ORDER DETAILS END  -->

        <!-- ORDER SEND INVOICE START  -->
        <div v-if="isPayment && !isPaymentTypeBill" class="application-box mb16">
          <div class="application-box__title">
            <p>{{ $t("forms.sendBill") }}</p>
          </div>

          <div class="application__label-box">
            <input v-model="isBill" @change="updatePaymentType" type="checkbox" id="send-bill" />
            <label for="send-bill">{{ $t("forms.agree") }}</label>
          </div>
        </div>
        <!-- ORDER SEND INVOICE END  -->

        <div class="application-box mb16">
          <input
            class="main-form__input"
            type="text"
            :disabled="!$guard('write', 'Orders') || !canEditOrder"
            :value="formatDiscount"
            @change="onDiscountChange"
            placeholder="Discount %"
            maxlength="2"
          />
        </div>

        <div class="application-box mb16">
          <input
            class="main-form__input"
            type="text"
            :disabled="!$guard('write', 'Orders') || !canEditOrder"
            v-model="dataEmployee.my_hammer"
            placeholder="MyHammer"
          />
        </div>

        <!-- ADMIN COMMENT START -->
        <div class="application-box application-comment-container mb16">
          <div class="application-box__title">{{ $t("forms.comment") }}:</div>
          <div class="input-group">
            <!-- <el-input
              :disabled="
                !$guard('write', 'Orders') && !$guard('writeComment', 'Orders')
              "
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="comment"
            ></el-input>-->

            <textarea
              class="main-form__textarea"
              v-model="comment"
              :disabled="
                !$guard('write', 'Orders') && !$guard('writeComment', 'Orders')
              "
              ref="admin-comment"
            ></textarea>
          </div>
        </div>
        <!-- ADMIN COMMENT END -->

        <!-- ORDER ATTACHMENTS START  -->
        <div class="application-box mb16" v-if="hasInvoice">
          <div
            class="application-box__title application-box__title_mb7"
          >{{ $t("forms.orderInvoice") }}</div>

          <div style="display: flex;align-items: center;">
            <svg
              height="30"
              viewBox="0 0 64 64"
              width="30"
              xmlns="http://www.w3.org/2000/svg"
              fill="var(--menu-text-color)"
            >
              <g id="Layer_17" data-name="Layer 17">
                <path
                  d="m62 1h-60a1 1 0 0 0 -1 1v60a1 1 0 0 0 1 1h60a1 1 0 0 0 1-1v-60a1 1 0 0 0 -1-1zm-1 2v18h-58v-18zm-58 58v-38h58v38z"
                />
                <path d="m8 7h2v10h-2z" />
                <path d="m37 7h2v10h-2z" />
                <path
                  d="m14 11.49 3.15 5a1 1 0 0 0 .85.51 1 1 0 0 0 .28 0 1 1 0 0 0 .72-1v-9h-2v5.51l-3.15-5a1 1 0 0 0 -1.13-.51 1 1 0 0 0 -.72 1v9h2z"
                />
                <path
                  d="m23.17 16.55a1 1 0 0 0 1.66 0l2-3a1 1 0 0 0 .17-.55v-6h-2v5.7l-1 1.5-1-1.5v-5.7h-2v6a1 1 0 0 0 .17.55z"
                />
                <path
                  d="m32 17a3 3 0 0 0 3-3v-4a3 3 0 0 0 -6 0v4a3 3 0 0 0 3 3zm-1-7a1 1 0 0 1 2 0v4a1 1 0 0 1 -2 0z"
                />
                <path
                  d="m44 17h1a3 3 0 0 0 3-3h-2a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h2a3 3 0 0 0 -3-3h-1a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3z"
                />
                <path d="m51 17h5v-2h-4v-2h4v-2h-4v-2h4v-2h-5a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1z" />
                <path
                  d="m58 27h-52a1 1 0 0 0 -1 1v30a1 1 0 0 0 1 1h52a1 1 0 0 0 1-1v-30a1 1 0 0 0 -1-1zm-1 6h-24v-4h24zm-26-4v4h-24v-4zm-24 6h24v22h-24zm26 22v-22h24v22z"
                />
                <path
                  d="m45 41a2 2 0 0 1 2 2h2a4 4 0 0 0 -3-3.86v-2.14h-2v2.14a4 4 0 0 0 1 7.86 2 2 0 1 1 -2 2h-2a4 4 0 0 0 3 3.86v2.14h2v-2.14a4 4 0 0 0 -1-7.86 2 2 0 0 1 0-4z"
                />
                <path d="m9 39h20v2h-20z" />
                <path d="m9 45h20v2h-20z" />
                <path d="m9 51h20v2h-20z" />
              </g>
            </svg>
            <a
              :href="dataEmployee.attachments.payment_invoice.url"
              target="_blank"
              style="text-decoration: underline; font-size: 13px;margin-left:16px"
            >{{ $t("forms.openOrderInvoice") }}</a>
          </div>
        </div>

        <div class="application-box mb16" v-if="hasActAcceptance">
          <div class="application-box__title application-box__title_mb7">{{ $t("forms.orderAct") }}</div>

          <div style="display: flex;align-items: center;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Outline"
              viewBox="0 0 512 512"
              width="30"
              height="30"
              fill="var(--menu-text-color)"
            >
              <path
                d="M72,496H368a111.991,111.991,0,0,0,48-213.179V120a8,8,0,0,0-2.343-5.657l-96-96A8,8,0,0,0,312,16H72A40.045,40.045,0,0,0,32,56V456A40.045,40.045,0,0,0,72,496ZM464,384a96,96,0,1,1-96-96A96.108,96.108,0,0,1,464,384ZM320,43.313,388.687,112H344a24.027,24.027,0,0,1-24-24ZM48,56A24.028,24.028,0,0,1,72,32H304V88a40.045,40.045,0,0,0,40,40h56V276.666A111.983,111.983,0,0,0,310.369,480H72a24.028,24.028,0,0,1-24-24Z"
              />
              <path d="M160,168a8,8,0,0,0,8,8H360a8,8,0,0,0,0-16H168A8,8,0,0,0,160,168Z" />
              <path d="M88,224H248a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M280,256H216a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" />
              <path d="M88,320H232a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M88,176h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M360,208H280a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" />
              <path d="M88,272h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M216,400H184a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" />
              <path d="M88,416h64a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M88,368h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M88,128h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" />
              <path d="M216,352H168a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
              <path
                d="M325.657,402.343a8,8,0,0,0-11.314,11.314l32,32A8,8,0,0,0,352,448q.394,0,.789-.039a8,8,0,0,0,5.868-3.523l64-96a8,8,0,0,0-13.312-8.876l-58.587,87.881Z"
              />
            </svg>

            <a
              :href="dataEmployee.attachments.act_acceptance.url"
              target="_blank"
              style="text-decoration: underline; font-size: 13px;margin-left:16px"
            >{{ $t("forms.openOrderAct") }}</a>
          </div>
        </div>
        <!-- ORDER ATTACHMENTS END  -->

        <!-- ORDER IS PAID START -->
        <div
          class="application-box application__paid mb16"
          v-if="isPaymentTypeBill && $guard('write', 'Orders') && isPayment"
        >
          <div class="application-box__title">{{ $t("listsHeader.status") }}</div>
          <div style="display: flex;align-items: center;" class="mb16">
            <input @change="updatePaidStatus" type="checkbox" id="updatePaidStatus" />
            <label for="updatePaidStatus">{{ $t("listsHeader.paid") }}</label>
          </div>
        </div>
        <!-- ORDER IS PAID END -->

        <div
          class="application-box mb16"
          v-if="isConfirmed || isStandBy || isPayment || isClosed || isRated"
        >
          <div class="application-box__title mb16">SMS senden</div>
          <button
            class="mr16 order-btn"
            v-if="isConfirmed || isStandBy"
            @click="showMessage('order-changed')"
          >Änderungen in dem Auftrag</button>
          <button
            class="order-btn"
            v-if="isPayment || isRated || isClosed"
            @click="showMessage('download-app-and-rate')"
          >App herunterladen</button>
        </div>
      </div>
    </div>

    <div class="application-box">
      <div class="application-box__title application-box__title_flex">
        Tags
        <svg
          style="cursor:pointer"
          @click="openTagsModal"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
          <path
            d="M8.00012 4.66669V11.3334"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3332 8H4.6665"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="application-employee__block" v-if="tags.length > 0">
        <div class="main-form__box tags">
          <div
            :ref="`tag_${item.id}`"
            class="tag tag_active tag_mr32"
            v-for="item in tags"
            :key="item.id"
          >
            <svg
              v-if="item.can_use_scooter"
              width="15"
              height="15"
              viewBox="0 0 25 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 8px"
            >
              <path
                d="M16.5906 3.45675C17.269 3.45675 17.8189 2.9068 17.8189 2.22841C17.8189 1.55001 17.269 1.00006 16.5906 1.00006C15.9122 1.00006 15.3622 1.55001 15.3622 2.22841C15.3622 2.9068 15.9122 3.45675 16.5906 3.45675Z"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.74017 18.2914H20.937"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.3465 5.53552L16.2126 6.95285L17.8189 14.3229H19.2363"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5276 5.81897H8.55908"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.78742 9.22052H3.74017"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.945 12.4331H7.42529"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20.9371 21.0315C22.4504 21.0315 23.6772 19.8047 23.6772 18.2914C23.6772 16.778 22.4504 15.5512 20.9371 15.5512C19.4237 15.5512 18.1969 16.778 18.1969 18.2914C18.1969 19.8047 19.4237 21.0315 20.9371 21.0315Z"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.74016 21.0315C5.2535 21.0315 6.48032 19.8047 6.48032 18.2914C6.48032 16.778 5.2535 15.5512 3.74016 15.5512C2.22681 15.5512 1 16.778 1 18.2914C1 19.8047 2.22681 21.0315 3.74016 21.0315Z"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.063 3.26776L20.0866 15.6457"
                stroke="#0C0C0C"
                stroke-width="1.4"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ item.name }}
            <span class="tag__close" @click="removeTag(item.id)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
                  fill="var(--menu-text-color)"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>

    <order-executors
      :responsible="dataEmployee.executors"
      :isSingle="!isMultiDays"
      :tags="tags"
      :service_id="service_id"
      :office_id="office_id"
      :address="dataEmployee.address"
      :duration="duration"
      :date="dataEmployee.should_started_at"
      @onConfirmResponsible="onConfirmResponsible"
      @onRemoveResponsible="onRemoveResponsible"
    />

    <div class="application-box">
      <div class="application-box__title application-box__title_flex">
        Dateien
        <svg
          style="cursor:pointer"
          @click="openFileModal"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
          <path
            d="M8.00012 4.66669V11.3334"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3332 8H4.6665"
            stroke="var(--menu-text-color)"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div class="application-employee__block">
        <files-list :files="files" @remove="removeFile" />
      </div>
    </div>

    <div
      class="application-box mb20"
      v-if="dataEmployee.change_logs && dataEmployee.change_logs.length > 0"
    >
      <div class="application-box__title application-box__title_flex">Geschichte</div>
      <history-list :singleDay="!isMultiDays" :history="dataEmployee.change_logs" />
    </div>

    <div
      class="application-box application-employee"
      :class="{
        'application-box_full': large,
      }"
      v-if="hasCanceled"
    >
      <div class="application-box__title">
        <p>Grund der Stornierung</p>
      </div>

      <p class="main-form__text">{{ dataEmployee.canceled.reason }}</p>
      <p class="main-form__text">{{ dataEmployee.canceled.comment }}</p>
    </div>

    <!-- ORDER BUTTONS START -->
    <div
      class="main-form__buttons main-form__buttons_center"
      :class="{
        'main-form__buttons_orders': !large,
      }"
      v-if="isNotClosed"
    >
      <button
        class="main-button main-button_cancel"
        :disabled="!$guard('delete', 'Orders')"
        @click="deleteModal(dataEmployee.id)"
      >
        <span>{{ $t("request.deleteRequest") }}</span>
      </button>
      <button class="main-button" :disabled="validate" @click="confirm">
        <span>{{ $t("global.save") }}</span>
      </button>
    </div>
    <!-- ORDER BUTTONS END -->

    <modal
      :show="showModalMedia"
      :outside="true"
      :dark="true"
      @close="closeModal"
      style="z-index: 99999"
    >
      <div class="media" style="position: relative">
        <div class="media__wrapper" v-bar>
          <div>
            <video :src="mediaSrc" controls class="media-player" v-if="typeMedia === 'video'"></video>
            <img :src="mediaSrc" alt v-else />
          </div>
        </div>
      </div>
    </modal>

    <modal
      :show="showMediaGallery"
      class="order-modal-images"
      :dark="true"
      @close="toggleMediaGallery"
    >
      <div class="media-gallery">
        <div class="media-gallery__item" v-for="item in dataEmployee.media" :key="item.id">
          <img :src="item.preview" alt @click="showMedia(item.original, item.type)" />
        </div>
      </div>
    </modal>

    <modal :show="showAutocomplete" :showBtn="false" :dark="true" @close="toggleAutocomplete">
      <autocomplete
        :autocompleteValue="autocompleteValue"
        @done="fillAddress"
        @close="toggleAutocomplete"
      />
    </modal>

    <modal
      :show="showDeleteReasonModal"
      :showBtn="false"
      :dark="true"
      @close="toggleDeleteReasonModal"
    >
      <reason-modal @close="toggleDeleteReasonModal" @done="rejectOrder" />
    </modal>

    <modal :show="isFileModalShow" :dark="true" :outside="false" @close="closeFileModal">
      <add-files @close="closeFileModal" @uploadFiles="uploadFiles" />
    </modal>

    <modal :show="isTagsShow" :dark="true" :outside="false" @close="closeTagsModal">
      <tags-modal :tags="tags" @close="closeTagsModal" @done="addTags" />
    </modal>

    <modal :show="isMaterialsShow" :dark="true" :outside="false" @close="closeMaterialsModal">
      <add-materials
        :serviceId="service_id"
        :materials="materials"
        @close="closeMaterialsModal"
        @done="updateMaterials"
      />
    </modal>
  </div>
</template>
<script>
import moment from 'moment'
import date from '@/mixins/date'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { signalingManager } from '@/utils/audioHandler'
import { notificationStore } from '@/utils/notificationStore'
import { i18n } from '@/plugins/vuei8n'
import { checkEmail } from '@/utils/checkEmail'

import autocomplete from '@/components/controls/autocomplete'
import addFiles from '@/components/modals/files/addFiles'
import addMaterials from '@/components/modals/orders/addMaterials'
import tagsModal from '@/components/modals/tags/tagsToOrder'
import filesList from '@/components/lists/files/filesList'
import historyList from '@/components/lists/history/historyList'
import recomendedPrice from '@/mixins/recomendedPrice'
import availableDateMixin from '@/mixins/availableDate'
import orderExecutors from '@/components/modals/orders/ordersExecutors'
import reasonModal from './reasonModal'

export default {
    props: ['dataEmployee', 'addNewApplication', 'openDeleteModal', 'large'],
    components: {
        autocomplete,
        reasonModal,
        addFiles,
        filesList,
        tagsModal,
        historyList,
        orderExecutors,
        addMaterials,
    },
    mixins: [date, recomendedPrice, availableDateMixin],
    data() {
        return {
            date: new Date(this.dataEmployee.date_from * 1000).toISOString(),
            madiaData: [],
            formMediaData: [],
            showModalAddresponsible: false,
            showModalMedia: false,
            typeMedia: 'image',
            mediaSrc: '',
            duration: '0',
            description: '',
            finalPrice: 0,
            comment: '',
            status: 'confirmed',
            statuses: [
                { value: 'new', label: 'new' },
                { value: 'confirmed', label: 'confirmed' },
            ],
            defaultImage: '/images/default-user.svg',
            statusesModified: null,
            autocompleteValue: '',
            isValidPhone: false,
            isBill: false,
            multiDays: [],
            showMediaGallery: false,
            showDeleteReasonModal: false,
            service_id: null,
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            isFileModalShow: false,
            entity_type: 'order',

            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
            service: null,
            isTagsShow: false,
            isMaterialsShow: false,
            tags: [],
            selectSetting: {
                placeholder: 'Office',
            },
            office_id: null,
            discount: null,
            materials: [],
        }
    },
    computed: {
        ...mapGetters({
            services: 'servicesGetters',
            statusesGetters: 'orders/statusesGetters',
            extraPrices: 'orders/extraPrices',
            showAutocomplete: 'autocomplete/showGetters',
            files: 'files/files',
            servicesFullData: 'servicesFullData',
            filteredList: 'offices/filteredList',
        }),
        clientAddress() {
            if (!this.dataEmployee.address.street) return 'Adresse hinzufügen'

            return `${this.dataEmployee.address.street} ${this.dataEmployee.address.house}, ${this.dataEmployee.address.postcode}, ${this.dataEmployee.address.city}`
        },
        validate() {
            if (
                !this.$guard('write', 'Orders')
        && !this.$guard('writeComment', 'Orders')
            ) {
                return true
            }

            if (this.dataEmployee.contact.first_name === '') return true
            if (this.dataEmployee.contact.last_name === '') return true
            if (this.dataEmployee.contact.phone === '') return true

            if (
                this.dataEmployee.contact.email === ''
        || this.dataEmployee.contact.email === undefined
        || !checkEmail(this.dataEmployee.contact.email)
            ) {
                return true
            }

            if (!this.dataEmployee.address.street) return true
            if (!this.isValidPhone) return true

            return this.dataEmployee.executors.length === 0
                && this.duration
                && this.status !== 'stand_by'
        },
        executors() {
            return this.dataEmployee.executors
        },
        hasCanceled() {
            return (
                this.dataEmployee.canceled && this.dataEmployee.canceled.reason !== null
            )
        },
        hasMaterials() {
            return this.dataEmployee.materials.length > 0
        },
        cannotEditDate() {
            return (
                this.status !== 'new'
        && this.status !== 'confirmed'
        && this.status !== 'stand-by'
            )
        },
        // canSendSms() {
        //   return this.status === "confirmed";
        // },
        isPayment() {
            return this.status === 'payment'
        },
        isPaymentTypeBill() {
            return this.dataEmployee.payment_type === 'bill'
        },
        isRated() {
            return this.dataEmployee.status === 'rating_review'
        },
        isNew() {
            return this.dataEmployee.status === 'new'
        },
        isConfirmed() {
            return this.dataEmployee.status === 'confirmed'
        },
        isStandBy() {
            return this.dataEmployee.status === 'stand_by'
        },
        isNotClosed() {
            return (
                this.dataEmployee.status !== 'closed'
        && this.dataEmployee.status !== 'canceled'
            )
        },
        isClosed() {
            return this.dataEmployee.status === 'closed'
        },
        hasInvoice() {
            return (
                this.dataEmployee.attachments
        && this.dataEmployee.attachments.payment_invoice
            )
        },
        hasActAcceptance() {
            return (
                this.dataEmployee.attachments
        && this.dataEmployee.attachments.act_acceptance
            )
        },
        hasClient() {
            return this.dataEmployee.client.first_name
        },
        hasDescription() {
            return this.dataEmployee.description
        },
        hasMedia() {
            return this.dataEmployee.media.length > 0
        },
        mutatedMedia() {
            if (this.dataEmployee.media) {
                return this.dataEmployee.media.slice(0, 3)
            }

            return []
        },
        isMultiDays() {
            return (
                !!this.dataEmployee.multi_days
        && this.dataEmployee.multi_days
        && this.dataEmployee.multi_days.length !== 0
            )
        },
        pickerOptions() {
            return {
                firstDayOfWeek: 1,
                selectableRange: ['00:00:00 - 23:00:00'],
                disabledDate: (time) => {
                    const hasMatch = this.availableDays.find((d) => {
                        const localDate = new Date(d)
                        localDate.setHours(0, 0, 0, 0)
                        return localDate.getTime() === time.getTime()
                    })

                    if (!hasMatch) {
                        return true
                    }
                },
            }
        },
        canEditOrder() {
            return (
                this.status !== 'payment'
        && this.status !== 'closed'
        && this.status !== 'rating_review'
        && this.status !== 'canceled'
            )
        },
        formatDiscount() {
            if (!this.discount) return 0

            return Math.round(this.discount)
        },
    },
    watch: {
        duration(value) {
            if (this.isMultiDays) {
                return
            }

            const service = this.servicesFullData.find(
                (item) => item.id === this.service_id,
            )
            const office = service.office_prices.find(
                (item) => item.id === this.office_id,
            )

            const prices = office === undefined
                ? {
                    price: 0,
                    price_fifteen: 0,
                }
                : office.prices

            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes

            let result = (sum - 60) / 15
            result = result === 0 ? 0 : result * prices.price_fifteen
            result = (result + prices.price) * (1 - this.discount / 100)

            this.setPriceByKey('servicePrice', prices.price)
            this.setPriceByKey('default', result)

            this.setPriceByKey(
                'executorsQuantity',
                this.dataEmployee.executors.length || 1,
            )
            this.setAvailableDays()
        },
        discount(v) {
            const localDiscount = v > 0 ? v / 100 : 0
            this.setPriceByKey('discount', localDiscount)
        },
    },
    methods: {
        ...mapMutations({
            toggleAutocomplete: 'autocomplete/toggleShow',
            clearFiles: 'files/clear',
        }),
        ...mapActions({
            fetchStatuses: 'orders/fetchStatuses',
            updateStatus: 'orders/updatePaidStatus',
            fetchExtraPrice: 'orders/fetchExtraPrice',
            sendSms: 'orders/sendSms',
            addFiles: 'files/add',
            fetchFiles: 'files/fetch',
            removeFileAction: 'files/remove',
        }),
        onDiscountChange(event) {
            this.discount = +event.target.value

            const office = this.service.office_prices.find(
                (item) => item.id === this.office_id,
            )
            const prices = office === undefined
                ? {
                    price: 0,
                    price_fifteen: 0,
                }
                : office.prices

            this.setOffice(prices)
        },
        getSmsText(event) {
            return event === 'order-changed'
                ? `Es wurden Änderungen an Ihrem Auftrag vorgenommen. Ein Handwerker wird Ihr Problem am ${moment(
                    this.dataEmployee.should_started_at,
                ).format('DD-MM-YYYY')} um ${moment(
                    this.dataEmployee.should_started_at,
                ).format('HH:mm')} Uhr lösen`
                : 'itte laden Sie unsere kostenlose App bei App Store oder Google Play :link herunter. Sie können uns auch gerne in Google unter dem Link bewerten :link'
        },
        showMessage(event) {
            this.$confirm(this.getSmsText(event), 'Nachrichtentext', {
                confirmButtonText: this.$t('global.ok'),
                cancelButtonText: this.$t('global.cancel'),
            })
                .then(async () => {
                    const { status } = await this.sendSms({
                        id: this.dataEmployee.id,
                        form: {
                            event,
                        },
                    })

                    if (status === 204) {
                        this.$notify({
                            title: 'Nachricht gesendet',
                            message: 'Nachricht wurde erfolgreich gesendet',
                            duration: 5000,
                        })
                    }
                })
                .catch(() => {})
        },
        onPriceChanged(v) {
            const price = +v.target.value

            if (price > this.price.servicePrice) {
                this.discount = 0
                this.setPriceByKey('default', price)
                return
            }
            const discount = 1 - price / this.price.servicePrice

            this.discount = discount * 100

            this.setPriceByKey('default', price)
        },
        onConfirmResponsible({
            data, hours, minutes, hasChanged,
        }) {
            this.dataEmployee.executors = data

            if (!this.isMultiDays) {
                this.dataEmployee.should_started_at = moment(
                    this.dataEmployee.should_started_at,
                )
                    .set('hours', hours)
                    .set('minutes', minutes)
                    .format()
            }

            if (!this.isMultiDays && hasChanged) {
                this.setPriceByKey(
                    'executorsQuantity',
                    this.dataEmployee.executors.length || 1,
                )
            }
        },
        onRemoveResponsible() {
            if (!this.isMultiDays) {
                this.setPriceByKey(
                    'executorsQuantity',
                    this.dataEmployee.executors.length || 1,
                )
            }
        },
        changeOffice() {
            const service = this.servicesFullData.find(
                (item) => item.id === this.service_id,
            )
            const office = service.office_prices.find(
                (item) => item.id === this.office_id,
            )

            const prices = office === undefined
                ? {
                    price: 0,
                    price_fifteen: 0,
                }
                : office.prices

            this.setOffice(prices)
            this.setExtraPrice()
        },
        getDurationPrice(office) {
            const hours = Number(this.duration.split(':')[0]) * 60
            const minutes = Number(this.duration.split(':')[1])
            const sum = hours + minutes

            let result = (sum - 60) / 15
            result = result === 0 ? 0 : result * office.price_fifteen
            return result
        },
        setOffice(office) {
            this.setPriceByKey('servicePrice', office.price)
            const officePrice = office.price + this.getDurationPrice(office)
            const price = this.discount ? officePrice * (1 - this.discount / 100) : officePrice

            this.setPriceByKey(
                'default',
                price,
            )
        },
        removeTag(id) {
            this.tags = this.tags.filter((item) => item.id !== id)
        },

        addTags(tags) {
            this.tags = tags
            this.closeTagsModal()
        },
        openTagsModal() {
            this.isTagsShow = true
        },
        closeTagsModal() {
            this.isTagsShow = false
        },
        closeMaterialsModal() {
            this.isMaterialsShow = false
        },
        openMaterialsModal() {
            this.isMaterialsShow = true
        },
        updateMaterials(data) {
            this.materials = [...data]
            this.calculateMaterials()
            this.closeMaterialsModal()
        },
        getPriceFromDuration(data) {
            const priceFifteen = data.price_fifteen
            const value = this.duration || '01:00'
            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes
            return ((sum - 60) / 15) * priceFifteen
        },
        changeService(id) {
            this.service = this.getServiceData(id)
            this.service_id = id

            if (this.office_id) {
                const office = this.service.office_prices.find(
                    (item) => item.id === this.office_id,
                )
                const prices = office === undefined
                    ? {
                        price: 0,
                        price_fifteen: 0,
                    }
                    : office.prices

                this.setOffice(prices)
            } else {
                const office = this.service.office_prices[0].prices
                this.setOffice(office)
            }

            this.setExtraPrice()
            this.setAvailableDays()
        },
        getServiceData(id) {
            return this.servicesFullData.filter((item) => item.id === id)[0]
        },
        closeFileModal() {
            this.isFileModalShow = false
        },
        openFileModal() {
            this.isFileModalShow = true
        },
        prepareFilesForm(files) {
            const fd = new FormData()
            files.forEach((file) => {
                fd.append('files[]', file)
            })
            fd.append('entity_type', this.entity_type)
            fd.append('entity_id', this.dataEmployee.id)

            return fd
        },
        async uploadFiles(files) {
            const isOkey = await this.addFiles(this.prepareFilesForm(files))
            if (!isOkey) return

            this.closeFileModal()
            this.getFiles()
        },
        async removeFile(id) {
            await this.removeFileAction(id)
            this.getFiles()
        },
        getFiles() {
            this.fetchFiles({
                entity_type: this.entity_type,
                entity_id: this.dataEmployee.id,
            })
        },
        getAddress(query) {
            const vm = this

            // eslint-disable-next-line no-undef
            const placeService = new google.maps.places.PlacesService(
                this.$refs.hidden_helper,
            )

            placeService.findPlaceFromQuery(
                {
                    query,
                    fields: ['place_id', 'geometry'],
                },
                (results, status) => {
                    // eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        placeService.getDetails(
                            {
                                placeId: results[0].place_id,
                                fields: ['address_components'],
                            },
                            (place) => {
                                const result = []
                                const fields = [
                                    'route',
                                    'street_number',
                                    'postal_code',
                                    'locality',
                                    'country',
                                ]

                                place.address_components.forEach((element) => {
                                    if (fields.lastIndexOf(element.types[0]) !== -1) {
                                        result.push(element)
                                    }
                                })

                                const data = {
                                    address: {
                                        index: result[4].long_name,
                                        country: result[3].long_name,
                                        city: result[2].short_name,
                                        route: result[1].short_name,
                                        short_name: result[0].short_name,
                                    },
                                    location: {
                                        lat: results[0].geometry.location.lat(),
                                        lng: results[0].geometry.location.lng(),
                                    },
                                }

                                vm.fillAddress(data)
                                // vm.toggleShowModalAdd();
                                // vm.setShowModalAdd(true);
                            },
                        )
                    }
                },
            )
        },
        async rejectOrder(form) {
            this.$emit('rejectOrder', {
                form,
                id: this.dataEmployee.id,
            })
        },
        toggleDeleteReasonModal() {
            this.showDeleteReasonModal = !this.showDeleteReasonModal
        },
        toggleMediaGallery() {
            this.showMediaGallery = !this.showMediaGallery
        },
        // autocomplete start
        openAutocomplete() {
            this.toggleAutocomplete()
        },
        fillAddress(data) {
            this.dataEmployee.address = {
                apartment: null,
                city: data.address.city,
                country: data.address.country,
                description: null,
                entrance: null,
                house: data.address.short_name,
                latitude: data.location.lat,
                longitude: data.location.lng,
                postcode: data.address.index,
                street: data.address.route,
            }
        },
        convertSource(source) {
            const values = {
                'admin-panel': 'Admin',
                'mobile-app-android': 'Android',
                'mobile-app-ios': 'iOS',
                'web-app': 'Web',
                'landing-page': 'Landing',
                'my-hammer': 'MyHammer',
            }

            return values[source] || ''
        },
        showResponsible() {
            this.showModalAddresponsible = !this.showModalAddresponsible
        },

        // update request
        updatePaidStatus() {
            this.updateStatus(this.dataEmployee.id)
            this.status = 'rating_review'
        },
        updatePaymentType() {
            this.dataEmployee.paymnet_type = 'bill'
        },

        getExecutors() {
            return this.dataEmployee.executors.map((value) => value.id)
        },
        getImageURL(image) {
            return `url(${image === null ? this.defaultImage : image}`
        },
        getImage(image) {
            return image === null ? this.defaultImage : image
        },
        prepareDates() {
            return this.multiDays.map((day) => moment(day).format('YYYY-MM-DD'))
        },
        prepareTags() {
            return this.tags.map((tag) => tag.id)
        },
        prepareForm() {
            const form = {
                date: Date.parse(this.dataEmployee.should_started_at),
                executors: this.getExecutors(),
                duration: this.duration,
                comment: this.comment,
                description: this.dataEmployee.description,
                status: this.status,
                address: this.dataEmployee.address,
                contact: {
                    phone: this.dataEmployee.contact.phone.replace(/\s+/g, ''),
                    first_name: this.dataEmployee.contact.first_name,
                    last_name: this.dataEmployee.contact.last_name,
                    email: this.dataEmployee.contact.email,
                    confirmed: this.dataEmployee.contact.confirmed,
                },
                client_id: this.dataEmployee.client.id,
                source: this.dataEmployee.source,
                service_id: this.service_id,
                my_hammer: this.dataEmployee.my_hammer,
                tags: this.prepareTags(),
                discount: +this.discount,
                materials: this.materials,
            }

            if (this.isBill) {
                form.paymnet_type = 'bill'
            }

            if (!this.isMultiDays) {
                form.single = {
                    datetime: moment(form.date).format('YYYY-MM-DD HH:mm'),
                    duration: this.duration,
                    final_price: this.recomendedFinalPrice - this.price.materialsPrice,
                }
            } else {
                form.multi_day = {
                    final_price: this.recomendedFinalPrice - this.price.materialsPrice,
                    dates: this.prepareDates(),
                }
            }

            return form
        },
        confirm() {
            this.$emit('updateRequest', this.dataEmployee.id, this.prepareForm())
            this.isBill = false
        },
        showMedia(link, type) {
            this.typeMedia = type
            this.mediaSrc = link
            this.showModalMedia = true
        },
        changeDate() {
            this.setExtraPrice()
        },
        // modal windows
        closeModal(v) {
            this.showModalAddresponsible = false
            this.showModalMedia = false
            if (document.querySelector('.media-player')) {
                document.querySelector('.media-player').pause()
            }

            if (v === 'cancel') this.dataEmployee.executors = []
        },
        deleteModal(id) {
            if (
                this.dataEmployee.status === 'new'
        || this.dataEmployee.status === 'stand_by'
            ) {
                this.showDeleteReasonModal = true
            } else {
                this.$emit('openDeleteModal', id)
            }
        },
        // helpers
        checkValue(v) {
            this.isValidPhone = v.valid
            this.dataEmployee.contact.phone = v.number.e164
        },

        async setStatus() {
            this.status = this.dataEmployee.status
            this.status = this.status === 'new' ? 'stand_by' : this.status

            await this.fetchStatuses()

            this.statusesModified = this.statusesGetters.filter(
                (e) => e.status !== 'canceled',
            )

            if (this.$config.mode === 'prod') {
                const statusIndex = this.statusesGetters.findIndex(
                    (e) => e.status === this.status,
                )

                this.statusesModified = this.statusesGetters.splice(
                    statusIndex - 1,
                    this.statusesGetters.length + 1,
                )

                this.statusesModified = this.statusesModified.filter(
                    (e) => e.status !== 'canceled',
                )
            }

            this.statusesModified = this.statusesModified.filter((item, index) => {
                if (index !== 0) {
                    item.value = i18n.t(`ordersStatus.${item.status}`)
                    return item
                }
            })
        },
        setDefaultClient() {
            if (this.dataEmployee.client === null) {
                this.dataEmployee.client = {}
            }
        },
        setFinalPrice() {
            this.finalPrice = this.dataEmployee.final_price
        },
        setComment() {
            this.comment = this.dataEmployee.comment ? this.dataEmployee.comment : ''
        },
        setDuration() {
            this.duration = this.dataEmployee.predicted_time
                ? this.dataEmployee.predicted_time.toString().replace(/\./g, ':')
                : '0'

            if (this.duration === '00:00') {
                this.duration = '01:00'
            }
        },
        handleSignaling() {
            if (notificationStore.has(this.dataEmployee.id)) {
                if (signalingManager.isPlaying) {
                    signalingManager.stop()
                }

                const notification = notificationStore.get(this.dataEmployee.id)
                if (notification) {
                    notification.close()
                }
                notificationStore.add(this.dataEmployee.id, null)
            }
        },
        setAutocomplete() {
            if (this.dataEmployee.address.street === '') return '-'

            this.autocompleteValue = `${this.dataEmployee.address.street} ${this.dataEmployee.address.house}`
        },
        setDates() {
            if (this.isMultiDays) {
                this.multiDays = this.dataEmployee.multi_days.map((day) => moment(day).format())
            }

            this.dataEmployee.should_started_at = moment(
                this.dataEmployee.should_started_at
          || moment()
              .set('hours', 8)
              .set('minutes', 0)
              .set('seconds', 0),
            ).format()
        },
        setDefaultAddress() {
            if (this.dataEmployee.address) return

            this.dataEmployee.address = {
                apartment: null,
                city: 'Vienna',
                country: 'Austria',
                description: null,
                entrance: null,
                house: '',
                latitude: null,
                longitude: null,
                postcode: '',
                street: '',
            }
        },
        setLandingFields() {
            if (
                (this.dataEmployee.landing && this.dataEmployee.status === 'new')
        || (this.dataEmployee.landing && this.dataEmployee.status === 'canceled')
            ) {
                const time = +this.dataEmployee.landing.time.split(':')[0]
                this.dataEmployee.should_started_at = this.dataEmployee.landing.date
                    ? moment(
                        moment(this.dataEmployee.landing.date, 'DD-MM-YYYY').set(
                            'hours',
                            time,
                        ),
                    ).format()
                    : moment(
                        moment()
                            .set('hours', 8)
                            .set('minutes', 0)
                            .set('seconds', 0),
                    ).format()

                this.dataEmployee.contact.phone = this.dataEmployee.landing.phone
                this.dataEmployee.contact.email = this.dataEmployee.landing.email
                this.comment = this.dataEmployee.landing.description

                if (this.dataEmployee.landing.address) {
                    this.getAddress(this.dataEmployee.landing.address)
                }

                if (this.dataEmployee.landing.name) {
                    const name = this.dataEmployee.landing.name.split(' ')
                    const [first_name, last_name] = name.split
                    this.dataEmployee.contact.first_name = first_name
                    this.dataEmployee.contact.last_name = last_name
                } else {
                    this.dataEmployee.contact.first_name = this.dataEmployee.client.first_name
                    this.dataEmployee.contact.last_name = this.dataEmployee.client.last_name
                }
            }
        },
        setService() {
            this.changeService(this.dataEmployee.service.id)
        },
        setDefaultPrice(fixedPrice = null) {
            this.setPriceByKey('executorsQuantity', 1)

            const percentOfDiscount = 100 - this.dataEmployee.discount
            // this.mutatedRecomendedFinalPrice = (fixedPrice * 100) / percentOfDiscount;
            this.setPriceByKey('default', (fixedPrice * 100) / percentOfDiscount)
            this.discount = +this.dataEmployee.discount
        },
        async setExtraPrice() {
            if (this.isMultiDays) return

            const localDate = this.dataEmployee.should_started_at
                ? moment(this.dataEmployee.should_started_at).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD')

            await this.fetchExtraPrice({
                service_id: this.service_id,
                office_id: this.office_id,
                date: localDate,
            })

            const key = moment(this.dataEmployee.should_started_at).format('HH:mm')
            const price = this.extraPrices[key] || 0

            const percent = price === 0 ? 1 : price / 100 + 1
            this.setPriceByKey('recomended', percent)
        },
        setTags() {
            this.tags = this.dataEmployee.work_tags || []
        },
        setDefaultOffice() {
            this.office_id = this.dataEmployee.office.id
        },
        setFieldHeight(ref) {
            const el = this.$refs[ref]

            if (!el) return

            el.style.height = `${el.scrollHeight}px`
        },
        calculateMaterials() {
            const materialsPrice = this.materials.reduce((accum, item) => item.price * item.qty, 0)

            this.setPriceByKey('materialsPrice', +materialsPrice)
        },
        setMaterials() {
            this.materials = this.dataEmployee.materials.map((item) => ({
                material_id: item.material.id,
                qty: item.qty,
                price: item.material.price,
                text: item.material.name.original,
                icon: item.material.icon.path,
            }))
            this.calculateMaterials()
        },
        init() {
            this.setDefaultClient()
            this.setDefaultAddress()
            this.setDefaultOffice()
            // this.setFinalPrice();
            this.setComment()
            this.setDuration()
            this.setStatus()
            this.handleSignaling()
            this.setAutocomplete()
            this.setDates()
            this.setService()
            this.setTags()
            this.setMaterials()

            this.setFieldHeight('admin-comment')
            this.setFieldHeight('client-comment')

            this.setLandingFields()
            this.setExtraPrice().then(() => {
                if (this.isNew) return
                this.setDefaultPrice(this.dataEmployee.final_price)
            })
            this.setAvailableDays()
        },
    },
    created() {
        this.init()
        this.getFiles()
    },
    beforeDestroy() {
        this.clearFiles()
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.order-btn {
  background: #bfbfbf;
  padding: 8px;
  border-radius: 4px;
  color: #000;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease-in;

  &:hover {
    background-color: #9a9898;
  }
}
.media-gallery {
  width: 800px;
  background-color: var(--bg-color);
  display: flex;
  flex-wrap: wrap;
  padding: 30px;
  border-radius: 10px;

  &__item {
    width: calc(25% - 16px);
    height: 140px;
    object-fit: cover;
    display: inline-block;
    margin-bottom: 16px;
    margin-right: 16px;

    img {
      width: 100%;
      height: 140px;
    }
  }

  &__btn {
    background-color: transparent;
    border: none;
    width: 170px;
    font-size: 11px;
    color: var(--menu-text-color);
  }
}

.closeModal {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 999999999999999;
  color: red;
  cursor: pointer;
  font-size: 30px;
}

.flex-row {
  display: flex;
}

.download-sheet {
  border: none;
  padding: 6px 20px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  background-color: #2e9e2e;
  transition: all 0.8s;

  &:hover {
    opacity: 0.9;
    background-color: #1f6d1f;
  }
}

.mt15 {
  margin-top: 15px;
}
</style>
<style>
.chat .application {
  width: 100%;
  height: 70vh;
}
</style>
<style lang="scss">
.form-input-number {
  width: 44px;
  height: 44px;
  margin-right: 16px;
  flex-shrink: 0;
  padding-left: 13px;
  color: #71bd4a;
  font-size: 16px;
}

.hide {
  display: none;
}

.application-info__newdate {
  & .date-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    cursor: pointer;

    &::placeholder {
      color: #71bd4a;
      font-size: 16px;
      text-decoration: underline;
    }
  }
}

.application-time__desc .el-date-editor--time-select {
  width: 100% !important;
}

.autocomplete-disable {
  box-sizing: border-box;
  cursor: pointer;
  padding-top: 9px !important;
  // input {
  //   cursor: pointer !important;
  //   background-color: #fff !important;
  //   color: #606266 !important;
  // }
}

.cannotEditDate {
  color: grey !important;
}

.cannotEditDate .date-input {
  background-color: #e0e0e0 !important;
  cursor: not-allowed;
}

.datetimeselect {
  position: absolute;
  top: 0;
  height: 40px;
}
</style>
<style>
.application-time-picker_w150 {
  width: 150px;
}

.application_order .multiple-days {
  width: 100% !important;
}

.order-modal__confirm-modal {
  position: absolute !important;
  right: 0;
  left: 0;
  margin: 0 auto;
  top: 30px;
}

.order-modal__confirm-modal .el-message-box__btns button:first-child {
  color: var(--menu-text-color) !important;
}
</style>
